// This is auto generated code, do not edit directly

export interface PossibleTypesResultData {
	possibleTypes: {
		[key: string]: string[];
	};
}
const result: PossibleTypesResultData = {
	possibleTypes: {
		DCRBadRequestForbidden: ['BadRequest', 'DCR', 'Forbidden'],
		DCRForbiddenResourceNotFound: ['DCR', 'Forbidden', 'ResourceNotFound'],
		DCRResultsForbiddenBadRequest: ['BadRequest', 'DCRResults', 'Forbidden'],
		EmailValueForbidden: ['EmailValue', 'Forbidden'],
		EventCreatedBadRequest: ['BadRequest', 'EventCreated'],
		ForbiddenBadRequestSignInResult: [
			'BadRequest',
			'Forbidden',
			'SignInResult'
		],
		ForbiddenServiceUnavailableInitiateAuthResult: [
			'Forbidden',
			'InitiateAuthResult',
			'ServiceUnavailable'
		],
		HCOAffiliatedHcpsResultsBadRequest: [
			'BadRequest',
			'HCOAffiliatedHcpsResults'
		],
		HCOAffiliationsResultsBadRequest: ['BadRequest', 'HCOAffiliationsResults'],
		HCOAutocompleteResultsBadRequest: ['BadRequest', 'HCOAutocompleteResults'],
		HCOAutocompleteResultsForbiddenBadRequest: [
			'BadRequest',
			'Forbidden',
			'HCOAutocompleteResults'
		],
		HCOHCPResourceNotFound: ['HCO', 'HCP', 'ResourceNotFound'],
		HCOHierarchyResultBadRequest: ['BadRequest', 'HCOHierarchyResult'],
		HCOResourceNotFound: ['HCO', 'ResourceNotFound'],
		HCOSearchAndFiltersBadRequest: ['BadRequest', 'HCOSearchAndFilters'],
		HCOSearchAndFiltersTypeHCPSearchAndFiltersType: [
			'HCOSearchAndFiltersType',
			'HCPSearchAndFiltersType'
		],
		HCOSearchResultsBadRequest: ['BadRequest', 'HCOSearchResults'],
		HCPAffiliationsResultsBadRequest: ['BadRequest', 'HCPAffiliationsResults'],
		HCPHCO: ['HCO', 'HCP'],
		HCPResourceNotFound: ['HCP', 'ResourceNotFound'],
		HCPSearchAndFiltersBadRequest: ['BadRequest', 'HCPSearchAndFilters'],
		HCPSearchResultsBadRequest: ['BadRequest', 'HCPSearchResults'],
		HcoFilterOptionSearchResultsBadRequest: [
			'BadRequest',
			'HcoFilterOptionSearchResults'
		],
		NoContentBadRequest: ['BadRequest', 'NoContent'],
		NoContentForbiddenResourceNotFound: [
			'Forbidden',
			'NoContent',
			'ResourceNotFound'
		],
		ProfileVisitResourceNotFound: ['ProfileVisit', 'ResourceNotFound'],
		ProfileVisitResultsBadRequest: ['BadRequest', 'ProfileVisitResults'],
		RecentHcoFilterSelectionResourceNotFound: [
			'RecentHcoFilterSelection',
			'ResourceNotFound'
		],
		RecentSearchBadRequest: ['BadRequest', 'RecentSearch'],
		RecentSearchResultsBadRequest: ['BadRequest', 'RecentSearchResults'],
		ReferenceResultBadRequest: ['BadRequest', 'ReferenceResult'],
		SearchAsYouTypeResultsBadRequest: ['BadRequest', 'SearchAsYouTypeResults'],
		SearchDownloadLinkForbiddenBadRequest: [
			'BadRequest',
			'Forbidden',
			'SearchDownloadLink'
		],
		SuggestedDCRFieldsForbiddenBadRequest: [
			'BadRequest',
			'Forbidden',
			'SuggestedDCRFields'
		],
		UnavailableFieldsForbiddenBadRequest: [
			'BadRequest',
			'Forbidden',
			'UnavailableFields'
		],
		UserBadRequestForbidden: ['BadRequest', 'Forbidden', 'User']
	}
};
export default result;
